import { Uuid } from "@/domains/global/identifiers";
import { resolveSyncModelNamespace } from "@/modules/uuid/sync-models/resolveSyncModelNamespace";
import { SyncModelKind } from "@/store/sync/types";
import { v5 as uuidv5 } from "uuid";

export const resolveSessionSyncModelUuid = ({
  spaceAccountId,
  sessionKey,
}: {
  spaceAccountId: Uuid;
  sessionKey: string;
}): Uuid => {
  const uppercaseSpaceAccountId = spaceAccountId.toUpperCase();
  const namespace = resolveSyncModelNamespace({
    modelKind: { value: SyncModelKind.Session },
  });
  const name = `${uppercaseSpaceAccountId}::${sessionKey}`;
  return uuidv5(name, namespace);
};
